import { render, staticRenderFns } from "./MultiGame.vue?vue&type=template&id=67450378&scoped=true"
import script from "./MultiGame.vue?vue&type=script&lang=js"
export * from "./MultiGame.vue?vue&type=script&lang=js"
import style0 from "./MultiGame.vue?vue&type=style&index=0&id=67450378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67450378",
  null
  
)

export default component.exports